import $ from 'jquery';

import { htmlspecialchars } from '../utils/htmlSpecialChars';

class Header {
	constructor($el) {
		// module vars declarations
		this.$el = $el;
		this.$navigation = this.$el.find(".header__nav-wrapper");
		this.$button = this.$el.find(".header__btn");
		this.$allSections = $("main > section, footer");
		this.$sections = $("main > section[data-main-nav-title], footer[data-main-nav-title]");
		this.$quickLinksMenu = this.$el.find('.header__quick-links-menu');
		this.$quickLinksMenuToggleLi = this.$quickLinksMenu.find('>li.menu-item-has-children');
		this.toggleClass = 'active';
		this.$logo = this.$el.find(".header__logo");
		this.lang = typeof $('html').attr('lang')!=='undefined' ? $('html').attr('lang') : false;
		this.lang = this.lang && $.trim(this.lang)!=='' ? $.trim(this.lang) : 'en';
		this.$menu = this.$el.find('.header__right');
		this.$searchToggle = this.$el.find('.header__search-toggle');
		this.$headerMenu = this.$el.find('.header__menu');
		this.$searchClose = this.$el.find('.header__search-form__close');

		this.$submenuToggleMobile = this.$el.find('.header__menu > .menu-item-has-children > a');
		this.$submenuToggleDesktop = this.$el.find('.header__menu > .menu-item-has-children');
		this.$secondLevelSubmenuToggle = this.$el.find('.header__menu > .menu-item-has-children > .sub-menu > .menu-item-has-children');
		this.$secondLevelSubmenuToggleMobile = this.$el.find('.header__menu > .menu-item-has-children > .sub-menu > .menu-item-has-children > a');
		// methods initialization
		this.init();
	}
	
	init() {
		// generate navigation links
		this.appendNavElements();

		// scroll back to top of the page
		//this.backToTop();

		// linking
		this.handleLinking();

		// toggle mobile menu on hamburger click event
		this.handleMobileMenu();

		// closes menu on click outside of menu element
		this.closeMenuOnClickOutsideMenu();

		// wrapper for last two menu items
		this.addCustomLinksWrapper();

		// search close mobile
		this.searchClose();

		// toggle search form
		this.initSearch();

		// submenu
		this.initSubMenu();

		// skip link
		this.skipLink();

		// resize submenu
		$(window).on('resize', () => {
			this.initSubMenu();
		  });
	}

	initSubMenu() {
		const that = this;

		this.$el.on('click', '.header__menu > .menu-item > a', function (e) {
			const $link = $(this);
			const href = $link.attr('href');
			if (href === '#') {
				e.preventDefault();
			  }
		});

		this.$el.on('click', '.header__menu > .menu-item-has-children > .sub-menu > .menu-item > a', function (e) {
			const $link = $(this);
			const href = $link.attr('href');
			if (href === '#') {
				e.preventDefault();
			  }
		});
		
		if(window.innerWidth >= 1280) {
		  this.$submenuToggleMobile.off();
		  this.$submenuToggleDesktop.off().on('mouseenter', function() {       
				that.openSubMenu($(this));
		  });

			// For tab navigation
			this.$el.find('.header__menu > .menu-item > a').off().on('focus', function() {
				// Close active menus
				// if(that.$submenuToggleDesktop.hasClass('active')) {
					that.$submenuToggleDesktop.removeClass('active');
				// }
			});

			// For tab navigation
		  this.$submenuToggleMobile.off().on('focus', function() {
				const parent = $(this).parent();
				
				that.$submenuToggleDesktop.removeClass('active');
				that.openSubMenu(parent);
		  });
	
		  this.$submenuToggleDesktop.off('mouseleave').on('mouseleave', function() {
				$(this).removeClass('active');
		  });
	
		  // Second level sub menu
		  this.$secondLevelSubmenuToggleMobile.off().on('click', function(e) {
			that.$el.find('.header__search-toggle').removeClass('active');
			that.$el.find('.header__search-form').removeClass('active');
			if($(this).parent().hasClass('active') === false) {
			  e.preventDefault();
			  that.$secondLevelSubmenuToggle.removeClass('active');
			  $(this).parent().addClass('active');
			} else {
				if($(this).attr('href') === '#') {
					$(this).parent().removeClass('active');
				}
			}
		  });
		} else {
			this.$submenuToggleDesktop.off();
			this.$submenuToggleMobile.off().on('click', function(e) {
			  const $link = $(this); // The clicked link
			  const href = $link.attr('href'); // Get the href attribute
			  const $parent = $link.parent(); // Parent menu item
		  
			  if (href === '#') {
				// Prevent default behavior for `#` links
				e.preventDefault();
		  
				// Toggle the active class
				if ($parent.hasClass('active')) {
				  $parent.removeClass('active');
				} else {
				  // Ensure only one menu is active at a time
				  that.$el.find('.header__menu .menu-item').removeClass('active');
				  $parent.addClass('active');
				}
			  } else {
				// Always navigate to real links
				return true;
			  }
			});

		  this.$secondLevelSubmenuToggleMobile.off().on('click', function(e) {    
			  const $link = $(this); // The clicked link
			  const href = $link.attr('href'); // Get the href attribute
			  const $parent = $link.parent(); // Parent menu item
		  
			  if (href === '#') {
				// Prevent default behavior for `#` links
				e.preventDefault();
		  
				// Toggle the active class
				if ($parent.hasClass('active')) {
				  $parent.removeClass('active');
				} else {
				  // Ensure only one menu is active at a time
				  that.$el.find('.header__menu > .menu-item > .sub-menu > .menu-item').removeClass('active');
				  $parent.addClass('active');
				}
			  } else {
				// Always navigate to real links
				return true;
			  }
		  });
		}
	}

	openSubMenu(element) {
		if(!element.hasClass('active')) {
			element.addClass('active');
			const $currentSecondLevelSubmenuToggle = element.find('.sub-menu > .menu-item-has-children');
			if (!$currentSecondLevelSubmenuToggle.hasClass('active')) {
				$currentSecondLevelSubmenuToggle.removeClass('active');
				$currentSecondLevelSubmenuToggle.first().addClass('active');
			}
		}
	}

	addCustomLinksWrapper() {
		const self = this;
		const handleResize = () => {
			if (window.innerWidth < 1280) {
				const $lastTwoItems = self.$headerMenu.find('li').slice(-2);
				if ($lastTwoItems.parent().parent().hasClass('header__custom-links')) return;

				const $wrapper = $('<li class="header__custom-links"><ul></ul></li>');
				$lastTwoItems.wrapAll($wrapper);			
			} else {
				const $customLinksWrapper = self.$headerMenu.find('.header__custom-links');
				if ($customLinksWrapper.length) {
					$customLinksWrapper.find('li').unwrap().unwrap();
				}
			}
		};

		$(window).on('resize', handleResize);
		handleResize();
	}

	searchClose() {
		this.$searchClose.on("click", (e) => {
			e.preventDefault();
			this.$el.find('.header__search-form').toggleClass('active');
			this.$searchToggle.toggleClass('active');
			this.$el.find('.header__custom-links').toggleClass('active');
			this.$el.find('.contact').toggleClass('hidden');
		});
	}

	initSearch() {
		const searchForm = this.$el.find('.header__search-form');
		const contact = this.$el.find('.contact');
	
		this.$searchToggle.on('click', (e) => {
			e.stopPropagation();


			if(!searchForm.hasClass('active')) {
				searchForm.find('input').focus();
			}

			if (searchForm.hasClass('active') && window.innerWidth < 1280) {
				this.$searchToggle.toggleClass('active');
				searchForm.submit();
				return;
			}
			if (window.innerWidth < 1280) {
				contact.toggleClass('hidden');
				this.$el.find('.header__custom-links').toggleClass('active');
			}
			this.$searchToggle.toggleClass('active');
			searchForm.toggleClass('active');
	
			if (window.innerWidth >= 1280 && searchForm.hasClass('active')) {
				$(document).on('click.searchForm', (event) => {
					if (!$(event.target).closest(searchForm).length && !$(event.target).is(this.$searchToggle)) {
						searchForm.removeClass('active');
						this.$searchToggle.removeClass('active');
						$(document).off('click.searchForm');
					}
				});
			}
		});
	}
	

	closeMenuOnClickOutsideMenu() {
		// const that = this;
		//$(document).on('click', function (e) {
		//	// Check if the clicked element or its ancestors contain the menu or button
		//	if (!$(e.target).closest('.header__nav-wrapper.active, .header__btn.active').length && $(document.body).hasClass('mobile-nav-active')) {
		//		if($(e.target)[0].nodeName.toLowerCase()!=='button'){
		//			that.toggleMobileMenu();
		//		}
		//	}
		//});

		// Prevent the click event on the menu from propagating to the document
		$('.header__nav-wrapper.active, .header__btn.active').on('click', function (e) {
			e.stopPropagation();
		});
	}

	appendNavElements() {
		const that = this;
		if (this.$sections.length > 0) {
			const menu = $("<ul class='header__menu'></ul>");
			let counter = 0;
			$(this.$sections).each(function (i, section) {
				const target = typeof $(section).data('nav-target') !== 'undefined' ? $.trim($(section).data('nav-target')) : false;
				const label = typeof $(section).data("main-nav-title") !== 'undefined' && $.trim($(section).data("main-nav-title")) !== '' ? htmlspecialchars($.trim($(section).data("main-nav-title"))) : false;
				let classes = label && typeof $(section).attr('class') !== 'undefined' ? $(section).attr('class') : false;
					classes = classes ? classes.split(' ') : classes;
				let sectionClass = classes && typeof classes[1] !== 'undefined' ? $.trim(classes[1]) : false;
					sectionClass = sectionClass ? `header__link header__link--${sectionClass}` : 'header__link';
					counter = label ? counter + 1 : counter;
					sectionClass += counter === 1 && that.$sections[0] === that.$allSections[0] ? ' active' : '';
				const specialSectionBgColor = $(this).hasClass('slides--bg-color-cream') ? 'cream' : ($(this).hasClass('slides--bg-color-green') ? 'green' : $(this).hasClass('slides--bg-color-purple') ? 'purple' : false);
					sectionClass += specialSectionBgColor ? ` header__link--special header__link--${specialSectionBgColor}` : '';
				const specialSectionSuptitle = $(this).hasClass('slides') && $(this).find('h3.slides__suptitle').length > 0 ? $(this).find('h3.slides__suptitle').text().split(' ')[0] : false;
				const ariaLabel = that.lang === 'sr' ? `Klikni da odskroluješ do ${label} sekcije` : `Click to scroll to ${label} section`;

				const li = label ? `<li><button class="${sectionClass}"${target ? ` aria-label="${ariaLabel}" data-for="${target}"` : ''} data-name="${label}">${specialSectionSuptitle ? `<sup>${specialSectionSuptitle}</sup>` : ''}${label}</button></li>` : '';
				menu.append(li);
			});
			
			// Wrap the entire menu inside a nav element
			const nav = $("<nav class='header__menu__nav'></nav>").append(menu);
			
			that.$navigation.find(".onepager").append(nav);
		}
	}

	backToTop() {
		if (typeof this.$logo !== "undefined") {
			$(this.$logo).on("click", function (e) {
				e.preventDefault();
				$("html, body").animate({ scrollTop: "0" });
				return false;
			});
		}
	}

	toggleMobileMenu() {
		$(document.body).toggleClass("mobile-nav-active");
		$(this.$button).toggleClass("active");
		$(this.$navigation).toggleClass("active");
		$(this.$menu).toggleClass('active');
	}

	handleLinking() {
		const that = this;
		if (this.$sections.length > 0) {
			$(this.$navigation).on("click", ".header__link", function () {
				const target = $(this).data('for');

				let targetFound = false; // Flag variable
				var windowWidth = $(window).outerWidth(true);
				var tabletWidth = $phpVars.breakpoint['screen-lg'];
				var topCorrectMultiplier = windowWidth<tabletWidth ? 0.12 : 0.12; 
				$(that.$sections).each(function (i, item) {
					if ($(this).data("nav-target") === target) {
						targetFound = true; // Set the flag

						// Calculate the distance between current scroll position and target section's position
						const distance = Math.abs($(item).offset().top - $(window).scrollTop());

						// Calculate the duration based on fixed scroll speed
						const scrollSpeed = 6000; // Adjust this value to set the scroll speed
						const duration = distance / scrollSpeed * 1000;

						$("html, body")
							.stop()
							.animate({ scrollTop: $(item).offset().top - topCorrectMultiplier * $(window).width() }, duration);
						return false; // Break the loop
					}
				});

				if (!targetFound) { // Check the flag
					return; // Exit the function if the target is not found
				}

				if ($(window).innerWidth() < $phpVars.breakpoint['screen-lg']) {
					that.toggleMobileMenu();
				}
			});
		}
	}

	handleMobileMenu() {
		const self = this;
		$(this.$button).on("click", function () {
			self.toggleMobileMenu();
		});
	}

	skipLink() {
		document.addEventListener('DOMContentLoaded', function () {
			const skipLink = document.querySelector('.skip-link');
		  
			skipLink.addEventListener('click', function () {
				skipLink.style.display = 'none';
			});
		});
	}
}

export default Header;
